import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 pb-5" }, null, -1 /* HOISTED */)

import { onMounted, onBeforeUnmount } from 'vue';
import Toasts from '@app/components/generic/toasts.vue';
import CollabStatusBanner from '@app/components/generic/collabStatusBanner.vue';
import store from '@app/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'base',
  setup(__props) {

let beforeUnloadHandler: null | ((event: BeforeUnloadEvent) => void) = null;

onMounted(() => {
  beforeUnloadHandler = (event: BeforeUnloadEvent) => {
    const hasUnsynced = Object.values(store.state.collabConnections)
      .some((entry) => entry.hasUnsyncedChanges);
    if (hasUnsynced) {
      event.preventDefault();
      // Required for some browsers (Chrome) to actually show the prompt.
      event.returnValue = '';
    }
  };
  window.addEventListener('beforeunload', beforeUnloadHandler);
});

onBeforeUnmount(() => {
  if (beforeUnloadHandler) {
    window.removeEventListener('beforeunload', beforeUnloadHandler);
    beforeUnloadHandler = null;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.fullPath
    })),
    _createVNode(Toasts),
    _createVNode(CollabStatusBanner),
    _hoisted_1
  ], 64 /* STABLE_FRAGMENT */))
}
}

})